module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "version"
  }, [_c('h2', [_vm._v("请选择线上版本")]), _vm._v(" "), _c('p', [_vm._v("更换版本会对用户造成无法预估的风险，请谨慎操作")]), _vm._v(" "), _c('p', [_c('bk-selector', {
    staticClass: "selector",
    attrs: {
      "list": _vm.list,
      "selected": _vm.defaultDemo.selected,
      "setting-key": 'version_id',
      "displayKey": 'name'
    },
    on: {
      "update:selected": function($event) {
        return _vm.$set(_vm.defaultDemo, "selected", $event)
      },
      "item-selected": _vm.selected
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "form-action"
  }, [_c('a', {
    staticClass: "bk-button bk-primary",
    attrs: {
      "title": "确定"
    },
    on: {
      "click": _vm.sendVersionId
    }
  }, [_c('span', [_vm._v("确定")])]), _vm._v(" "), _c('a', {
    staticClass: "bk-button",
    attrs: {
      "title": "取消"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_c('span', [_vm._v("取消")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-50e557ed!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/personal_center/works/change_version.vue
// module id = 3BPl
// module chunks = 16